import store from '../store';
import router from '../router';
export function check_permissions(from,to,next){
    let canGoThrough = true;
    let foundPermission = false;
    let admin = false;
    if(store.getters.user && store.getters.user.website_role && store.getters.user.website_role.name==='admin'){
        admin = true;
    }
    if(store.getters.user.user_websites){
        if(to.params.id && !admin && store.getters.user.user_websites){
            store.getters.user.user_websites.forEach(webPerm=>{
                if(webPerm.id == to.params.id){
                    admin = true;
                }
            })
        }
        if(!admin){
            if(to.params.id !=='create'){
                if(to.meta.user_permission){
                    store.getters.user.website_permissions.forEach(permission=>{
                        let paramId = to.params.id ? to.params.id : store.getters.activeWebsite.id;
                        if((permission.type === to.meta.user_permission) && (permission.value === 0) && (permission.user_permission.website_id == paramId)){
                            foundPermission = true;
                        }
                    })
                }
            }
        }
        if(foundPermission) return false;
    }

    return canGoThrough;
}
